import { Lock, Users } from "lucide-react"

import { Button } from "@/components/ui/button"

// No teams yet — the create-your-first-team hero (design 599-610, template cards
// dropped to a single CTA).
export function NoTeamsHero({ onCreate }) {
  return (
    <div className="flex h-[calc(100vh-69px)] min-h-[560px] flex-col items-center justify-center bg-accent px-10 text-center">
      <div className="mb-[18px] grid size-16 place-items-center rounded-[18px] bg-[var(--red-soft)] text-primary">
        <Users className="size-[30px]" strokeWidth={1.7} />
      </div>
      <h2 className="font-display text-[22px] font-bold tracking-[-0.4px]">Build your first team</h2>
      <p className="mt-2 max-w-[520px] text-[13.5px] leading-[1.6] text-ink-3">
        Teams bring the freelancers you trust into one shared space — chat in channels and collaborate on
        projects without hunting through separate threads.
      </p>
      <Button className="mt-[18px]" onClick={onCreate}>
        Create a team
      </Button>
    </div>
  )
}

// Feature-gated state — TEAM_BUILD is off. Honest copy, navigation intact (no
// redirect), per ADR-011 M4.
export function GatedState() {
  return (
    <div className="flex h-[calc(100vh-69px)] min-h-[560px] flex-col items-center justify-center bg-accent px-10 text-center">
      <div className="mb-[18px] grid size-16 place-items-center rounded-[18px] border border-border bg-secondary text-ink-3">
        <Lock className="size-7" strokeWidth={1.7} />
      </div>
      <h2 className="font-display text-lg font-bold tracking-[-0.3px]">Teams isn&apos;t on your plan</h2>
      <p className="mt-2 max-w-[420px] text-[13.5px] leading-[1.55] text-ink-3">
        Team workspaces let you bring freelancers together in shared channels. Reach out to support if you
        think this should be available on your account.
      </p>
    </div>
  )
}

// Empty active team — no members or orders yet. Rendered inside the #general
// conversation intro (the invite/share CTA, design 458-459) so it is handled by
// ConversationView; this is the fallback hero for the management pages.
export function EmptyTeam({ onInvite, onShare }) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center bg-accent px-10 text-center">
      <div className="mb-[18px] grid size-[58px] place-items-center rounded-2xl border border-border bg-card text-ink-3">
        <Users className="size-[26px]" strokeWidth={1.6} />
      </div>
      <h3 className="font-display text-base font-bold tracking-[-0.2px]">Your team is ready</h3>
      <p className="mt-1.5 max-w-[360px] text-[13px] leading-[1.55] text-ink-3">
        Invite freelancers you&apos;ve worked with and share a project to get the conversation going.
      </p>
      <div className="mt-[18px] flex gap-2.5">
        <Button onClick={onInvite}>Invite freelancer</Button>
        <Button variant="outline" onClick={onShare}>Share a project</Button>
      </div>
    </div>
  )
}
